import { Duration } from "../../../google/protobuf/duration";
import * as _m0 from "protobufjs/minimal";
import { Long } from "@osmonauts/helpers";
function createBaseQuery() {
  return {
    id: "",
    connectionId: "",
    chainId: "",
    queryType: "",
    requestData: new Uint8Array(),
    callbackModule: "",
    callbackId: "",
    callbackData: new Uint8Array(),
    timeoutDuration: undefined,
    timeoutTimestamp: Long.UZERO,
    requestSent: false
  };
}
export const Query = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.connectionId !== "") {
      writer.uint32(18).string(message.connectionId);
    }
    if (message.chainId !== "") {
      writer.uint32(26).string(message.chainId);
    }
    if (message.queryType !== "") {
      writer.uint32(34).string(message.queryType);
    }
    if (message.requestData.length !== 0) {
      writer.uint32(42).bytes(message.requestData);
    }
    if (message.callbackModule !== "") {
      writer.uint32(106).string(message.callbackModule);
    }
    if (message.callbackId !== "") {
      writer.uint32(66).string(message.callbackId);
    }
    if (message.callbackData.length !== 0) {
      writer.uint32(98).bytes(message.callbackData);
    }
    if (message.timeoutDuration !== undefined) {
      Duration.encode(message.timeoutDuration, writer.uint32(114).fork()).ldelim();
    }
    if (!message.timeoutTimestamp.isZero()) {
      writer.uint32(72).uint64(message.timeoutTimestamp);
    }
    if (message.requestSent === true) {
      writer.uint32(88).bool(message.requestSent);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;
        case 2:
          message.connectionId = reader.string();
          break;
        case 3:
          message.chainId = reader.string();
          break;
        case 4:
          message.queryType = reader.string();
          break;
        case 5:
          message.requestData = reader.bytes();
          break;
        case 13:
          message.callbackModule = reader.string();
          break;
        case 8:
          message.callbackId = reader.string();
          break;
        case 12:
          message.callbackData = reader.bytes();
          break;
        case 14:
          message.timeoutDuration = Duration.decode(reader, reader.uint32());
          break;
        case 9:
          message.timeoutTimestamp = reader.uint64();
          break;
        case 11:
          message.requestSent = reader.bool();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$id, _object$connectionId, _object$chainId, _object$queryType, _object$requestData, _object$callbackModul, _object$callbackId, _object$callbackData, _object$timeoutDurati, _object$requestSent;
    const message = createBaseQuery();
    message.id = (_object$id = object.id) !== null && _object$id !== void 0 ? _object$id : "";
    message.connectionId = (_object$connectionId = object.connectionId) !== null && _object$connectionId !== void 0 ? _object$connectionId : "";
    message.chainId = (_object$chainId = object.chainId) !== null && _object$chainId !== void 0 ? _object$chainId : "";
    message.queryType = (_object$queryType = object.queryType) !== null && _object$queryType !== void 0 ? _object$queryType : "";
    message.requestData = (_object$requestData = object.requestData) !== null && _object$requestData !== void 0 ? _object$requestData : new Uint8Array();
    message.callbackModule = (_object$callbackModul = object.callbackModule) !== null && _object$callbackModul !== void 0 ? _object$callbackModul : "";
    message.callbackId = (_object$callbackId = object.callbackId) !== null && _object$callbackId !== void 0 ? _object$callbackId : "";
    message.callbackData = (_object$callbackData = object.callbackData) !== null && _object$callbackData !== void 0 ? _object$callbackData : new Uint8Array();
    message.timeoutDuration = (_object$timeoutDurati = object.timeoutDuration) !== null && _object$timeoutDurati !== void 0 ? _object$timeoutDurati : undefined;
    message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? Long.fromValue(object.timeoutTimestamp) : Long.UZERO;
    message.requestSent = (_object$requestSent = object.requestSent) !== null && _object$requestSent !== void 0 ? _object$requestSent : false;
    return message;
  }
};
function createBaseDataPoint() {
  return {
    id: "",
    remoteHeight: "",
    localHeight: "",
    value: new Uint8Array()
  };
}
export const DataPoint = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.remoteHeight !== "") {
      writer.uint32(18).string(message.remoteHeight);
    }
    if (message.localHeight !== "") {
      writer.uint32(26).string(message.localHeight);
    }
    if (message.value.length !== 0) {
      writer.uint32(34).bytes(message.value);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;
        case 2:
          message.remoteHeight = reader.string();
          break;
        case 3:
          message.localHeight = reader.string();
          break;
        case 4:
          message.value = reader.bytes();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$id2, _object$remoteHeight, _object$localHeight, _object$value;
    const message = createBaseDataPoint();
    message.id = (_object$id2 = object.id) !== null && _object$id2 !== void 0 ? _object$id2 : "";
    message.remoteHeight = (_object$remoteHeight = object.remoteHeight) !== null && _object$remoteHeight !== void 0 ? _object$remoteHeight : "";
    message.localHeight = (_object$localHeight = object.localHeight) !== null && _object$localHeight !== void 0 ? _object$localHeight : "";
    message.value = (_object$value = object.value) !== null && _object$value !== void 0 ? _object$value : new Uint8Array();
    return message;
  }
};
function createBaseGenesisState() {
  return {
    queries: []
  };
}
export const GenesisState = {
  encode(message, writer = _m0.Writer.create()) {
    for (const v of message.queries) {
      Query.encode(v, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.queries.push(Query.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$queries;
    const message = createBaseGenesisState();
    message.queries = ((_object$queries = object.queries) === null || _object$queries === void 0 ? void 0 : _object$queries.map(e => Query.fromPartial(e))) || [];
    return message;
  }
};